import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import { BankName } from '../generated-types';
import { getBankName } from '../services/profileService';

const useBankInfo = (enabled = true): QueryResult<BankName> =>
    useQuery<BankName>({
        queryKey: ['bankinfo'],
        queryFn: getBankName,
        refetchOnWindowFocus: true,
        enabled,
        retry: 1,
    });

export default useBankInfo;
